function convertToCSV(data) {
    const csvRows = [];

    // Get headers
    const headers = Object.keys(data[0]);
    csvRows.push(headers.join(','));

    // Loop over the rows and push them to csvRows
    // eslint-disable-next-line no-restricted-syntax
    for (const row of data) {
        const values = headers.map(header => {
            const escaped = (`${  row[header]}`).replace(/"/g, '\\"');
            return `"${escaped}"`;
        });
        csvRows.push(values.join(','));
    }

    return csvRows.join('\n');
}

// eslint-disable-next-line import/prefer-default-export
export function exportToCSV(data, filename) {
    const csvContent = convertToCSV(data);
    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = url;
    a.download = filename;

    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
}

// This helper is used to download the CSV file returned from the API response.
export const downloadFile = (url) => {
    const a = document.createElement('a');
    a.href = url;
    
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };